webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_functions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(13);





var steps = {
  selectVehicle: {
    id: 'selectVehicle',
    stepNumber: 1,
    title: 'Enter Your Vehicle',
    passedValidation: false,
    stickyNavigationOptions: {
      visible: true,
      buttons: {
        nextButton: {
          text: 'Find Your System',
          buttonClass: 'stickynav-button-full button__solid--blue',
          linkTo: 'selectSystem',
          requireStepValidation: true
        }
      }
    }
  },
  selectSystem: {
    id: 'selectSystem',
    stepNumber: 2,
    title: 'Choose Your System',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  selectCommunication: {
    id: 'selectCommunication',
    stepNumber: 3,
    title: 'Choose Your Communication Type',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  selectRemote: {
    id: 'selectRemote',
    stepNumber: 4,
    title: 'Choose Your Remote',
    passedValidation: false,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  selectUpgrades: {
    id: 'selectUpgrades',
    stepNumber: 5,
    title: 'Add System Upgrades',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: {
        nextButton: {
          text: 'Add Accessories',
          buttonClass: 'stickynav-button-full button__solid--blue',
          linkTo: 'viewSystem',
          requireStepValidation: true
        }
      }
    }
  },
  viewSystem: {
    id: 'viewSystem',
    stepNumber: 6,
    title: 'Your System is Complete',
    passedValidation: false,
    stickyNavigationOptions: {
      visible: true,
      buttons: null
    }
  },
  contactDealer: {
    id: 'contactDealer',
    passedValidation: true,
    stickyNavigationOptions: {
      visible: true,
      buttons: {
        backButton: {
          text: 'Return to System',
          buttonClass: 'stickynav-button-full button__outline--grey',
          linkTo: 'viewSystem',
          requireStepValidation: false
        }
      }
    }
  }
};

var store = {
  debug: true,
  state: {
    remoteStart: true,
    security: false,
    remoteStartSecurity: false,
    vehicleObject: {
      year: 'Vehicle Year'
    },
    customFields: {},
    dataFromExternal: false,
    selectedMake: 'Vehicle Make',
    selectedModel: 'Vehicle Model',
    selectedYear: 'Vehicle Year',
    selectedYearValue: 'Vehicle Year',
    vehicleMakesData: [],
    vehicleModelsData: [],
    vehicleYearsData: [],
    VehicleManualYearsData: [],
    remotes: null,
    filteredRemotes: null,
    accessories: null,
    steps: steps,
    progressBarSteps: 1,
    selectableOptions: [{
      id: 0,
      name: 'Smartphone Control',
      selected: false,
      locked: false,
      lockedMessage: '',
      productId: 240
    }, {
      id: 1,
      name: 'GPS Tracking',
      selected: false,
      locked: false,
      lockedMessage: '',
      productId: 240
    }, {
      id: 2,
      name: 'Keyless Touch Entry',
      selected: false,
      locked: false,
      lockedMessage: '',
      productId: 237
    }, {
      id: 3,
      name: 'ALARMIT KIT',
      selected: false,
      locked: false,
      lockedMessage: 'Since you want to remote start and secure your car, we have added the Alarm It kit for you. This will add the ability to secure your car.',
      productId: 228
    }],
    selectedUpgrades: [],
    selectedRemote: {},
    selectedSystem: {},
    selectedSystemCategory: '',
    selectedCommunication: '',
    selectedRemoteId: 0,
    customerDetails: {
      customerName: '',
      customerEmail: '',
      customerZip: '',
      customerPhone: ''
    },
    formPassedValidation: false,
    currentStep: steps.selectVehicle,
    currentRoute: '',
    selectedDealer: {},
    vehicleJson: null,
    dealers: null,
    dealerLatLon: {},
    systemString: '',
    systems: {},
    showNav: true,
    showVehicleContinueButton: true,
    showMainNav: true,
    inquiryDataSaved: false,
    numberQuotesRequested: 0,
    inquiryId: null,
    showProDealers: false
  },
  holdVehicleJson: function holdVehicleJson(responseData) {
    this.state.vehicleJson = responseData;
  },
  updateNumberQuotesRequested: function updateNumberQuotesRequested() {
    this.state.numberQuotesRequested = this.state.numberQuotesRequested + 1;
    this.numberQuotesRequestedToState();
  },
  updatePhoneNumber: function updatePhoneNumber(phoneNumber) {
    this.state.customerDetails.customerPhone = phoneNumber;
  },
  numberQuotesRequestedToState: function numberQuotesRequestedToState() {
    // Save requests made to local storage
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('requestsMade', this.state.numberQuotesRequested, 60 * 60 * 1000);
  },
  getRequestNumberFromStorage: function getRequestNumberFromStorage() {
    // Get number of requests made from local storage
    var requestsFromStorage = parseInt(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('requestsMade'));

    if (requestsFromStorage) {
      this.state.numberQuotesRequested = requestsFromStorage;
    } else {
      this.state.numberQuotesRequested = 0;
    }
  },
  changeFormValidationState: function changeFormValidationState(bool) {
    this.state.formPassedValidation = bool;
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('formValidation', bool, 60 * 60 * 1000);
  },
  toggleVehicleContinueButton: function toggleVehicleContinueButton(bool) {
    this.state.showVehicleContinueButton = bool;
  },
  updateVehicleObject: function updateVehicleObject(vehicleMake, vehicleModel, vehicleYearId) {
    var makeValue = vehicleMake;
    var modelValue = vehicleModel;
    var yearId = vehicleYearId;
    var selectedVehicle = {};

    var vehicleMakes = this.state.vehicleJson.makes[0];

    for (var i in vehicleMakes) {
      if (i === makeValue) {
        vehicleMake = vehicleMakes[i];
        for (var x in vehicleMake) {
          if (vehicleMakes[i][x].id.toString() === yearId) {
            selectedVehicle = vehicleMakes[i][x];
          }
        }
      }
    }

    this.state.vehicleObject = selectedVehicle;
    this.state.vehicleObject.make = makeValue;
    this.state.vehicleObject.model = modelValue;

    this.state.selectedMake = makeValue;
    this.state.selectedModel = modelValue;
    this.state.selectedYearValue = selectedVehicle.year;

    // Set vehicle local storage
    var currentStateToString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.vehicleObject);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('vehicle', currentStateToString, 60 * 60 * 1000);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedMake', this.state.selectedMake, 60 * 60 * 1000);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedModel', this.state.selectedModel, 60 * 60 * 1000);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedYear', this.state.selectedYear, 60 * 60 * 1000);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedYearValue', selectedVehicle.year, 60 * 60 * 1000);
  },
  updateCurrentStateRoute: function updateCurrentStateRoute(currentRoute) {
    this.state.currentRoute = currentRoute;
    this.state.currentStep = this.state.steps[currentRoute];

    // Save current step and steps local storage
    this.setStepsLocalStorage();
  },
  toggleMainNav: function toggleMainNav() {
    if (this.state.showMainNav) {
      this.state.showMainNav = false;
    } else {
      this.state.showMainNav = true;
    }
  },
  updateCurrentStep: function updateCurrentStep(newValue) {
    this.state.currentStep = newValue;
  },
  holdRemotes: function holdRemotes(responseObj) {
    this.state.remotes = responseObj;
    // Stores remotes in local storage to halt additional ajax call for remotes
    var remotesString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(responseObj);

    // change loadingRemotes on state object to j

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('remotes', remotesString, 60 * 60 * 1000);
  },
  holdSystems: function holdSystems(responseObj) {
    this.state.systems = responseObj;
    // Stores systems in local storage to halt additional ajax call for systems
    var systemsString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(responseObj);

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('systems', systemsString, 60 * 60 * 1000);
  },
  holdAccessories: function holdAccessories(responseObj) {
    this.state.accessories = responseObj;
    // Store systems in local storage
    var accessoriesString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(responseObj);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('accessories', accessoriesString, 60 * 60 * 1000);
  },
  holdCustomFields: function holdCustomFields(responseObj) {
    this.state.customFields = responseObj;

    // Store custom fields in local storage
    var customFieldsString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(responseObj);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('customFields', customFieldsString, 60 * 60 * 1000);
  },
  removeOptionLocks: function removeOptionLocks() {
    for (var option in this.state.selectableOptions) {
      this.state.selectableOptions[option].locked = false;
    }
  },
  holdSelectedSystem: function holdSelectedSystem(str) {
    this.state.selectedSystemCategory = str;

    if (str === 'MAX IT') {
      this.state.remoteStartSecurity = true;
      this.state.remoteStart = false;
      this.state.security = false;
    } else if (str === 'START IT') {
      this.state.remoteStartSecurity = false;
      this.state.remoteStart = true;
      this.state.security = false;
    } else if (str === 'ALARM IT') {
      this.state.remoteStartSecurity = false;
      this.state.remoteStart = false;
      this.state.security = true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_2__helpers_functions__["a" /* default */].isEmpty(this.state.selectedRemote)) {
      this.updateSelectedSystem();
    }

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedSystemCategory', str, 60 * 60 * 1000);

    // Save steps to local storage
    this.setStepsLocalStorage();
    this.setLocalStorageSystem();
  },
  setSelectedCommunication: function setSelectedCommunication(str) {
    this.state.selectedCommunication = str;

    this.filterRemoteList();

    // Save communication type and filtered remotes to local storage
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('communicationType', str, 60 * 60 * 1000);

    // Save steps to local storage
    this.setStepsLocalStorage();
  },
  setCategorySelectionState: function setCategorySelectionState(category) {
    switch (category) {
      case 'remoteStart':
        this.state.security = false;
        this.state.remoteStart = true;
        this.state.remoteStartSecurity = false;

        // Loop through each selectableOption and remove locks
        this.removeOptionLocks();

        break;
      case 'security':
        this.state.security = true;
        this.state.remoteStart = false;
        this.state.remoteStartSecurity = false;

        // Loop through each selectableOption and remove locks
        this.removeOptionLocks();

        break;
      case 'remoteStartSecurity':
        this.state.security = false;
        this.state.remoteStart = false;
        this.state.remoteStartSecurity = true;

        // Check if vehicle specific ID
        // change to remote start and add ALARMIT KIT kit
        if (this.state.vehicleObject.vehicleSpecificId) {
          for (var option in this.state.selectableOptions) {
            if (this.state.selectableOptions[option].name === 'ALARMIT KIT') {
              this.updateSelectedAttribute(this.state.selectableOptions[option].id);
            }
          }
        }

        break;
      default:
    }
  },
  updateSelectedAttribute: function updateSelectedAttribute(upgradeId) {
    // Loop through attributes to find matching object
    for (var upgrade in this.state.accessories) {
      if (this.state.accessories[upgrade].ID === upgradeId) {
        var duplicateInArray = false;
        var upgradeIndex;

        // Set selected status
        if (this.state.accessories[upgrade].selected) {
          this.state.accessories[upgrade].selected = false;

          // Remove attribute from selectedUpgrades
          // upgradeIndex = this.state.selectedUpgrades.indexOf(this.state.accessories[upgrade])

          var filteredSelectedUpgrades = this.state.selectedUpgrades.filter(function (el) {
            return el.ID !== upgradeId;
          });

          this.state.selectedUpgrades = filteredSelectedUpgrades;

          // if (upgradeIndex > -1) {
          //   this.state.selectedUpgrades.splice(upgradeIndex, 1)
          // }
        } else {
          this.state.accessories[upgrade].selected = true;

          // Add upgrade to selectedUpgrades
          // Check if upgradeId already exists before pushing a duplicate
          for (var selectedUpgrades in this.state.selectedUpgrades) {
            if (this.state.selectedUpgrades[selectedUpgrades].ID === upgradeId) {
              duplicateInArray = true;
            }
          }

          if (duplicateInArray === false) {
            // Push upgrade onto array
            this.state.selectedUpgrades.push(this.state.accessories[upgrade]);
          } else {
            upgradeIndex = this.state.selectedUpgrades.indexOf(this.state.accessories[upgrade]);

            this.state.selectedUpgrades.splice(upgradeIndex, 1);
          }
        }

        this.setOptionsLocalStorage();
      }
    }
  },
  updateSelectedRemoteId: function updateSelectedRemoteId(remoteId) {
    this.state.selectedRemoteId = remoteId;

    if (remoteId !== 0) {
      // Loop through remotes to find matching ID
      for (var currentRemote in this.state.remotes) {
        if (this.state.remotes[currentRemote].ID === remoteId) {
          this.updateSelectedRemoteObj(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.remotes[currentRemote])));

          // If PRO remote add flag to be able to filter dealer list to PRO only
          if (this.state.remotes[currentRemote].post_title.indexOf('PRO') !== -1) {
            this.state.showProDealers = true;
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('showProDealers', true, 60 * 60 * 1000);
          } else {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('showProDealers', false, 60 * 60 * 1000);
          }
        }
      }
    } else {
      this.updateSelectedRemoteObj(0);
    }
  },
  updateSelectedRemoteObj: function updateSelectedRemoteObj(obj) {
    this.state.selectedRemote = obj;

    this.state.steps['selectRemote'].passedValidation = true;

    // Update local storage
    this.setLocalStorageRemote();

    // Save steps to local storage
    this.setStepsLocalStorage();
  },
  updateSelectedSystem: function updateSelectedSystem() {
    // Determine the correct system based on remote, system category, and vehicle make
    var currentCompatibleSystems = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.systems));
    var currentVehicleSpecificId = this.state.vehicleObject.vehicleSpecificId;
    var currentVehicleMake = this.state.vehicleObject.make;

    // Check vehicle object for vehicle specific id, then check if remote is compatible with that system
    // If remote is not compatible with that system, return a universal system
    if (currentVehicleSpecificId !== '') {
      // If selected category is security, ignore vehicle specific system and assign alarm it
      if (this.state.security === true) {
        // Search compatible systems for alarm it system
        for (var currentSystem in currentCompatibleSystems) {
          if (currentCompatibleSystems[currentSystem].model_number === 'FT-7300A-CONT') {
            // Assign current system as selectedSystem
            this.state.selectedSystem = currentCompatibleSystems[currentSystem];
            this.setOptionsLocalStorage();
            return;
          }
        }

        // If loop does not return value default to first system
        this.state.selectedSystem = currentCompatibleSystems[0];
        this.setOptionsLocalStorage();
        return;
      } else {
        for (var system in currentCompatibleSystems) {
          if (currentCompatibleSystems[system].harness_model_numbers) {
            // Get all compatible makes
            var allCompatibleMakes = currentCompatibleSystems[system].compatible_makes;
            var isMakeCompatible = false;
            // Check all compatible makes for selected make
            for (var compatibleMake in allCompatibleMakes) {
              if (allCompatibleMakes[compatibleMake] === currentVehicleMake) {
                isMakeCompatible = true;
              }
            }

            var lengthOfHarnesses = __WEBPACK_IMPORTED_MODULE_2__helpers_functions__["a" /* default */].objectLength(currentCompatibleSystems[system].harness_model_numbers);
            var loopCounter = 0;

            // Loop through harness_model_numbers and check for a matching vehicleSpecificID
            for (var tHarnessId in currentCompatibleSystems[system].harness_model_numbers) {
              if (currentCompatibleSystems[system].harness_model_numbers[tHarnessId].model_number === currentVehicleSpecificId && isMakeCompatible) {
                // Assign current system as selectedSystem
                this.state.selectedSystem = currentCompatibleSystems[system];
                this.setLocalStorageSystem();
                // Check if remote start and security category option
                // If so change to remote start and add ALARMIT KIT kit
                if (this.state.remoteStartSecurity) {
                  for (var option in this.state.selectableOptions) {
                    if (this.state.selectableOptions[option].name === 'FT-7300A-CONT') {
                      this.updateSelectedAttribute(this.state.selectableOptions[option].productId);
                      this.setOptionsLocalStorage();
                      this.setLocalStorageSystem();
                    }
                  }
                }
                return;
              }

              loopCounter += 1;

              // If reach the end of the loop and no results, set as default system
              if (loopCounter === lengthOfHarnesses + 1) {
                this.state.selectedSystem = currentCompatibleSystems[0];
                this.setLocalStorageSystem();
                return;
              }
            }
          }
        }
      }
      this.setLocalStorageSystem();
    } else if (this.state.remoteStart === 'true' || this.state.remoteStart === true) {
      for (var theSystem in currentCompatibleSystems) {
        if (currentCompatibleSystems[theSystem].model_number === 'FT-7200S-CONT') {
          // Assign current system as selectedSystem
          this.state.selectedSystem = currentCompatibleSystems[theSystem];
          this.setLocalStorageSystem();
          return;
        }
      }
      // If loop does not return value default to first system
      this.state.selectedSystem = currentCompatibleSystems[0];
      this.setLocalStorageSystem();
      return;
    } else if (this.state.security === 'true' || this.state.security === true) {
      for (theSystem in currentCompatibleSystems) {
        if (currentCompatibleSystems[theSystem].model_number === 'FT-7300A-CONT') {
          // Assign current system as selectedSystem
          this.state.selectedSystem = currentCompatibleSystems[theSystem];
          this.setLocalStorageSystem();
          return;
        }
      }
      // If loop does not return value default to first system
      this.state.selectedSystem = currentCompatibleSystems[0];
      this.setLocalStorageSystem();
      return;
    } else if (this.state.remoteStartSecurity === 'true' || this.state.remoteStartSecurity === true) {
      for (theSystem in currentCompatibleSystems) {
        if (currentCompatibleSystems[theSystem].model_number === 'FT-7000AS-CONT') {
          // Assign current system as selectedSystem
          this.state.selectedSystem = currentCompatibleSystems[theSystem];
          this.setLocalStorageSystem();
          return;
        }
      }
      // If loop does not return value default to first system
      this.state.selectedSystem = currentCompatibleSystems[0];
      this.setLocalStorageSystem();
      return;
    } else {
      this.state.selectedSystem = currentCompatibleSystems[0];
      this.setLocalStorageSystem();
      return;
    }
  },
  filterRemoteList: function filterRemoteList() {
    var filteredRemotesList = [];
    var currentRemotes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.remotes));

    // Loop through remotes and check if remote is compatible with selected system
    for (var currentRemote in currentRemotes) {
      // Filter based on compatible system
      for (var compatibleSystem in currentRemotes[currentRemote].compatible_systems) {
        if (currentRemotes[currentRemote].compatible_systems[compatibleSystem].ID === this.state.selectedSystem.ID) {
          // Now check if communication matches
          for (var currentTerm in currentRemotes[currentRemote].terms) {
            if (currentRemotes[currentRemote].terms[currentTerm].slug === this.state.selectedCommunication) {
              // If both match, push to filtered list
              filteredRemotesList.push(currentRemotes[currentRemote]);
            }
          }
        }
      }
    }

    // Convert the array to an object
    filteredRemotesList = filteredRemotesList.reduce(function (result, item, index, array) {
      result[index] = item;
      return result;
    }, {});

    // Update the state with filtered remotes
    this.state.filteredRemotes = filteredRemotesList;

    // Filtered remote list to local storage
    var filteredRemotesString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteredRemotesList);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('filteredRemotes', filteredRemotesString, 60 * 60 * 1000);
  },
  updateSystemStringState: function updateSystemStringState(str) {
    this.state.systemString = str;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('systemstring', str, 60 * 60 * 1000);
  },
  updateDealersState: function updateDealersState(obj) {
    this.state.dealers = obj;
    // Set local storage after dealers retrieved
    store.setInquiryDataLocalStorage();
  },
  updateMapState: function updateMapState(str) {
    this.state.mapString = str;
  },
  updateCurrentStepValidation: function updateCurrentStepValidation(bool) {
    var currentStepKey = this.state.currentStep.id;
    this.state.currentStep.passedValidation = bool;
    this.state.steps[currentStepKey].passedValidation = bool;

    this.setStepsLocalStorage();
  },
  setStepsLocalStorage: function setStepsLocalStorage() {
    var stepsString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.steps);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('steps', stepsString, 60 * 60 * 1000);

    var currentStepString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.currentStep);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('currentStep', currentStepString, 60 * 60 * 1000);
  },
  getStepsLocalStorage: function getStepsLocalStorage() {
    var stepsString = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('steps', '');
    var stateStepsString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.steps);

    if (stepsString !== '' && stateStepsString !== stepsString) {
      var stepsObj = JSON.parse(stepsString);
      this.state.steps = stepsObj;

      // Set current step from local storage
      var currentStepString = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('currentStep', stepsObj[0]);
      this.state.currentStep = JSON.parse(currentStepString);
    }
  },
  checkLocalStorageRemotes: function checkLocalStorageRemotes() {
    var localStorageRemotes = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('remotes', '');
    if (localStorageRemotes !== '') {
      var localStorageRemotesObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('remotes'));
      this.state.remotes = localStorageRemotesObj;
    }
  },
  setLocalStorageRemote: function setLocalStorageRemote() {
    if (this.state.steps.selectRemote.passedValidation) {
      var currentRemoteString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.selectedRemote);
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedRemote', currentRemoteString, 60 * 60 * 1000);
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('remoteID', this.state.selectedRemoteId, 60 * 60 * 1000);

      this.setStepsLocalStorage();
    }
  },
  setLocalStorageSystem: function setLocalStorageSystem() {
    var currentSystemString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.selectedSystem);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedSystem', currentSystemString, 60 * 60 * 1000);
  },
  setOptionsLocalStorage: function setOptionsLocalStorage() {
    // Set options data
    var selectableOptionsString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.selectableOptions);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectableOptions', selectableOptionsString, 60 * 60 * 1000);

    // Set selectedUpgrades data
    var selectedUpgradesString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.selectedUpgrades);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('selectedUpgrades', selectedUpgradesString, 60 * 60 * 1000);

    // Set accessories data
    var accessoriesString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.accessories);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('accessories', accessoriesString, 60 * 60 * 1000);
  },
  setInquiryDataLocalStorage: function setInquiryDataLocalStorage() {
    // Store inquiry info
    var customerInfoString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.customerDetails);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('customerDetails', customerInfoString, 60 * 60 * 1000);
    // Store dealer list
    var dealerListString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.dealers);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('dealers', dealerListString, 60 * 60 * 1000);
    // Steps to local storage
    this.setStepsLocalStorage();
  },
  inquiryDataSaved: function inquiryDataSaved(inquiryId) {
    this.state.inquiryDataSaved = true;
    this.state.inquiryId = inquiryId;

    // Store inquiry id in local storage
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('inquiryId', inquiryId, 60 * 60 * 1000);
  },
  updateManualYears: function updateManualYears(arr) {
    this.state.VehicleManualYearsData = arr;
  },
  getStateObj: function getStateObj() {
    var cleanedSelectedRemote = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.selectedRemote));
    cleanedSelectedRemote.compatible_systems = false;

    var cleanedSelectedSystem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.selectedSystem));
    cleanedSelectedSystem.compatible_systems = false;

    var currentStateData = {
      remoteStart: this.state.remoteStart,
      security: this.state.security,
      remoteStartSecurity: this.state.remoteStartSecurity,
      vehicleObject: this.state.vehicleObject,
      customFields: this.state.customFields,
      selectedMake: this.state.selectedMake,
      selectedModel: this.state.selectedModel,
      selectedYear: this.state.selectedYear,
      selectedYearValue: this.state.selectedYearValue,
      selectedUpgrades: this.state.selectedUpgrades,
      selectedRemote: cleanedSelectedRemote,
      selectedSystem: cleanedSelectedSystem,
      selectedSystemCategory: this.state.selectedSystemCategory,
      selectedCommunication: this.state.selectedCommunication,
      selectedRemoteId: this.state.selectedRemoteId,
      currentStep: this.state.currentStep,
      currentRoute: this.state.currentRoute,
      systemString: this.state.systemString,
      showNav: true,
      inquiryDataSaved: true,
      inquiryId: this.state.inquiryId
    };
    return currentStateData;
  },
  updateStateWithData: function updateStateWithData(obj) {
    if (obj.remoteStart === 'true') {
      this.state.remoteStart = true;
    } else {
      this.state.remoteStart = false;
    }

    if (obj.security === 'true') {
      this.state.security = true;
    } else {
      this.state.security = false;
    }

    if (obj.remoteStartSecurity === 'true') {
      this.state.remoteStartSecurity = true;
    } else {
      this.state.remoteStartSecurity = false;
    }

    this.state.vehicleObject = obj.vehicleObject;
    this.state.customFields = obj.customFields;
    this.state.selectedMake = obj.selectedMake;
    this.state.selectedModel = obj.selectedModel;
    this.state.selectedYear = obj.selectedYear;
    this.state.selectedYearValue = obj.selectedYearValue;
    this.state.selectedUpgrades = obj.selectedUpgrades;
    this.state.selectedRemote = obj.selectedRemote;
    this.state.selectedSystem = obj.selectedSystem;
    this.state.selectedSystemCategory = obj.selectedSystemCategory;
    this.state.selectedCommunication = obj.selectedCommunication;
    this.state.selectedRemoteId = obj.selectedRemoteId;
    this.state.formPassedValidation = false;
    this.state.currentStep = obj.currentStep;
    this.state.currentRoute = obj.currentRoute;
    this.state.systemString = obj.systemString;

    if (obj.inquiryDataSaved === 'true') {
      this.state.inquiryDataSaved = true;
    } else {
      this.state.inquiryDataSaved = false;
    }

    this.state.inquiryId = obj.inquiryId;
  },
  getStoreDataToSave: function getStoreDataToSave() {
    // Package up necessary data
    var data = {
      remoteStart: this.state.remoteStart,
      security: this.state.security,
      remoteStartSecurity: this.state.remoteStartSecurity,
      selectedRemoteId: this.state.selectedRemote.ID,
      selectedRemoteName: this.state.selectedRemote.post_title,
      selectedVehicle: this.state.vehicleObject,
      selectedUpgrades: this.state.selectedUpgrades,
      customerEmail: this.state.customerDetails.customerEmail,
      customerName: this.state.customerDetails.customerName,
      customerPhone: this.state.customerDetails.customerPhone,
      customerZip: this.state.customerDetails.customerZip,
      systemName: this.state.systemString,
      systemId: this.state.selectedSystem.ID

      // Return obj
    };return data;
  },
  clearLocalStorage: function clearLocalStorage() {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.clear();
  },
  getLocalStorage: function getLocalStorage() {
    // Get Steps
    this.getStepsLocalStorage();

    // Get vehicle object
    var vehicleObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('vehicle', '{}'));

    if (!__WEBPACK_IMPORTED_MODULE_2__helpers_functions__["a" /* default */].isEmpty(vehicleObject)) {
      this.state.vehicleObject = vehicleObject;
    }
    this.state.selectedMake = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('selectedMake', 'Vehicle Make');
    this.state.selectedModel = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('selectedModel', 'Vehicle Model');
    this.state.selectedYear = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('selectedYear', 'Vehicle year');
    this.state.selectedYearValue = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('selectedYearValue', 'Vehicle Year');
    this.state.dataFromExternal = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('dataSent', false);

    // Get selected category
    this.state.selectedSystemCategory = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('selectedSystemCategory');

    // Get communication type and filtered remotes
    var communicationTypeString = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('communicationType');
    var filteredRemotesObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('filteredRemotes'));

    if (communicationTypeString !== '') {
      this.state.selectedCommunication = communicationTypeString;
      this.state.filteredRemotes = filteredRemotesObject;
    }

    // Get selected remote
    var remoteIdLocalStorage = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('remoteID');
    if (remoteIdLocalStorage) {
      this.state.selectedRemote = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('selectedRemote'));
      this.state.selectedRemoteId = remoteIdLocalStorage;

      // Get Selected system
      this.state.selectedSystem = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('selectedSystem'));
      this.state.systemString = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('systemstring');

      // Get PRO status
      this.state.showProDealers = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('showProDealers');
    }

    // Get remotes
    var localStorageRemotes = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('remotes', '');
    if (localStorageRemotes !== '') {
      var localStorageRemotesObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('remotes'));
      this.state.remotes = localStorageRemotesObj;

      // Get accessories
      var localStorageAccessoryObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('accessories'));
      this.state.accessories = localStorageAccessoryObj;

      // Get custom fields
      var customFieldsObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('customFields'));
      this.state.customFields = customFieldsObject;

      var localStorageRemoteFeatures = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('remoteFeatures');
      if (localStorageRemoteFeatures !== '') {
        // Get remote features
        var remoteFeaturesArray = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('remoteFeatures'));
        this.state.remoteFeatures = remoteFeaturesArray;
      }
    }

    // Get contact details
    var customerDetailsObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('customerDetails'));
    var dealerListObject = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('dealers'));
    this.state.inquiryId = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('inquiryId'));

    this.state.formPassedValidation = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('formValidation', false);

    if (dealerListObject && customerDetailsObject) {
      this.state.customerDetails = customerDetailsObject;
      this.state.dealers = dealerListObject;
    }
  },
  resetBuilder: function resetBuilder() {
    // Reset values on state
    this.state.selectedMake = 'Vehicle Make';
    this.state.selectedModel = 'Vehicle Model';
    this.state.selectedYear = 'Vehicle year';
    this.state.selectedYearValue = 'Vehicle year';
    this.state.selectedRemote = {};
    this.state.selectedRemoteId = 0;
    this.state.selectedSystem = {};
    this.state.selectedSystemCategory = '';
    this.state.remoteStart = false;
    this.state.remoteStartSecurity = false;
    this.state.security = false;
    this.state.steps = steps;
    this.state.selectedUpgrades = [];
    this.state.systemString = '';
    this.state.vehicleObject.year = 'Vehicle Year';
    this.state.customerDetails.customerEmail = '';
    this.state.customerDetails.customerName = '';
    this.state.customerDetails.customerZip = '';
    this.state.customerDetails.customerPhone = '';
    this.state.formPassedValidation = false;
    this.state.inquiryDataSaved = false;
    this.state.numberQuotesRequested = 0;
    this.state.inquiryId = null;
    this.state.vehicleObject = { year: 'Vehicle Year' };
    this.state.vehicleModelsData = [];
    this.state.vehicleYearsData = [];

    // Make sure validation is correct on steps
    this.state.steps.selectVehicle.passedValidation = false;
    this.state.steps.selectRemote.passedValidation = false;

    // Get accessories from local storage and mutate
    // Loop through accessories and set status to unselected
    var localStorageAccessoryObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('accessories'));

    for (var currentAccessory in localStorageAccessoryObj) {
      localStorageAccessoryObj[currentAccessory].selected = false;
    }

    // Put cleaned accessories back into local state
    var localStorageAccessoryString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageAccessoryObj);
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.set('accessories', localStorageAccessoryString, 60 * 60 * 1000);

    // reset values on local storage
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('communicationType');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('filteredRemotes');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('remoteID');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedMake');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedModel');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedRemote');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedSystem');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedSystemCategory');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedUpgrades');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedYear');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('selectedYearValue');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('steps');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('currentStep');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('vehicle');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('systemstring');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('requestsMade');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('customerDetails');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('dealers');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('formValidation');
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('inquiryId');

    // Change route to select vehicle
    store.updateCurrentStateRoute('selectVehicle');
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'selectVehicle' });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_steps_SelectVehicle__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_steps_SelectVehicle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_steps_SelectVehicle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_steps_SelectSystem__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_steps_SelectSystem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_steps_SelectSystem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_steps_SelectCommunicationType__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_steps_SelectCommunicationType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_steps_SelectCommunicationType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_steps_SelectUpgrades__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_steps_SelectUpgrades___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_steps_SelectUpgrades__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_steps_SelectRemote__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_steps_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_steps_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_steps_ViewSystem__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_steps_ViewSystem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_steps_ViewSystem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_steps_ContactDealer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_steps_ContactDealer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_steps_ContactDealer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_steps_ThankYou__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_steps_ThankYou___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_steps_ThankYou__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_steps_DealerFollowup__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_steps_DealerFollowup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_steps_DealerFollowup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowupComplete__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowupComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowupComplete__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'selectVehicle',
    component: __WEBPACK_IMPORTED_MODULE_2__components_steps_SelectVehicle___default.a
  }, {
    path: '/select-system',
    name: 'selectSystem',
    component: __WEBPACK_IMPORTED_MODULE_3__components_steps_SelectSystem___default.a
  }, {
    path: '/select-communication',
    name: 'selectCommunicationType',
    component: __WEBPACK_IMPORTED_MODULE_4__components_steps_SelectCommunicationType___default.a
  }, {
    path: '/select-remote',
    name: 'selectRemote',
    component: __WEBPACK_IMPORTED_MODULE_6__components_steps_SelectRemote___default.a
  }, {
    path: '/select-upgrades',
    name: 'selectUpgrades',
    component: __WEBPACK_IMPORTED_MODULE_5__components_steps_SelectUpgrades___default.a
  }, {
    path: '/view-system/',
    name: 'viewSystem',
    component: __WEBPACK_IMPORTED_MODULE_7__components_steps_ViewSystem___default.a
  }, {
    path: '/view-system/:inquiryId/:quoteId',
    name: 'viewSystem',
    component: __WEBPACK_IMPORTED_MODULE_7__components_steps_ViewSystem___default.a,
    props: true
  }, {
    path: '/contact-dealer',
    name: 'contactDealer',
    component: __WEBPACK_IMPORTED_MODULE_8__components_steps_ContactDealer___default.a
  }, {
    path: '/thank-you/:inquiryId/:quoteId',
    name: 'thankYou',
    component: __WEBPACK_IMPORTED_MODULE_9__components_steps_ThankYou___default.a,
    props: true
  }, {
    path: '/dealer-followup/:inquiryId/:quoteId',
    name: 'dealerFollowup',
    component: __WEBPACK_IMPORTED_MODULE_10__components_steps_DealerFollowup___default.a,
    props: true
  }, {
    path: '/dealer-followup-complete/:inquiryId/:quoteId',
    name: 'dealerFollowup',
    component: __WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowupComplete___default.a,
    props: true
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 120 };
    }
  }
}));

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(422),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(423),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(434),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(421),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(416),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(425),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_steps_ViewSystem__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_steps_ViewSystem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_steps_ViewSystem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_steps_ConfigureSystem__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_steps_ConfigureSystem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_steps_ConfigureSystem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_steps_SelectRemote__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_steps_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_steps_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_steps_ContactInfo__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_steps_ContactInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_steps_ContactInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_steps_ContactDealer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_steps_ContactDealer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_steps_ContactDealer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_steps_ThankYou__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_steps_ThankYou___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_steps_ThankYou__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowup__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_steps_DealerFollowupComplete__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_steps_DealerFollowupComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_steps_DealerFollowupComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jquery__);
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_ls___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a, ConfigureSystem: __WEBPACK_IMPORTED_MODULE_6__components_steps_ConfigureSystem___default.a, SelectRemote: __WEBPACK_IMPORTED_MODULE_7__components_steps_SelectRemote___default.a, ViewSystem: __WEBPACK_IMPORTED_MODULE_5__components_steps_ViewSystem___default.a, ContactInfo: __WEBPACK_IMPORTED_MODULE_8__components_steps_ContactInfo___default.a, ContactDealer: __WEBPACK_IMPORTED_MODULE_9__components_steps_ContactDealer___default.a, DealerFollowup: __WEBPACK_IMPORTED_MODULE_11__components_steps_DealerFollowup___default.a, DealerFollowupComplete: __WEBPACK_IMPORTED_MODULE_12__components_steps_DealerFollowupComplete___default.a, ThankYou: __WEBPACK_IMPORTED_MODULE_10__components_steps_ThankYou___default.a }
});

// Fix window height issue
__WEBPACK_IMPORTED_MODULE_13_jquery___default()('#root').css('display', 'inline');

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  isEmpty: function isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({});
  },
  objectLength: function objectLength(obj) {
    var length = 0;
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        ++length;
      }
    }
    return length;
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reusable_header_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reusable_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_reusable_header_vue__);
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { headerNav: __WEBPACK_IMPORTED_MODULE_3__components_reusable_header_vue___default.a },
  name: 'app',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state
    };
  },

  methods: {
    retrieveProducts: function retrieveProducts() {
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].toggleVehicleContinueButton(false);

      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'text',
        timeout: 7000,
        data: {
          action: 'system-builder-get-remotes'
        },
        cache: false,
        success: function success(response) {
          var jsonObj = JSON.parse(response);
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].holdRemotes(jsonObj.remotes);
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].holdCustomFields(jsonObj.custom_fields);
          __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].toggleVehicleContinueButton(true);
          return false;
        }
      });
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getLocalStorage();
    if (this.sharedState.remotes === null) {
      this.retrieveProducts();
    }
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dealerItem',
  props: ['dealerId', 'dealerPro', 'dealerPhone', 'dealerEmail'],
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].state,
      dealerId: this.dealerId,
      dealerPro: this.dealerPro,
      dealerPhone: this.dealerPhone,
      dealerEmail: this.dealerEmail,
      emailButtonLoading: false,
      emailSent: false
    };
  },

  methods: {
    sendQuoteToDealer: function sendQuoteToDealer() {
      this.emailButtonLoading = true;
      var self = this;

      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'text',
        data: {
          action: 'system-builder-send-quote-request',
          dealerId: this.dealerId,
          inquiryId: this.sharedState.inquiryId
        },
        cache: false,
        success: function success(response) {
          // Update button state
          self.changeEmailButtonToSent();

          // Update number of requests on state
          __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].updateNumberQuotesRequested();
          return false;
        },
        error: function error(err) {
          console.log('AJAX error in request: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err, null, 2));
        }
      });
    },
    changeEmailButtonToSent: function changeEmailButtonToSent() {
      this.emailButtonLoading = false;
      this.emailSent = true;
    },
    prepareTelLink: function prepareTelLink(val) {
      return 'tel:' + val;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__store_index__["a" /* default */].getRequestNumberFromStorage();
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'remoteItem',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state,
      active: false,
      remoteId: this.id
    };
  },

  props: ['id', 'remoteKey'],
  methods: {
    toggleSelected: function toggleSelected() {
      var selectedRemoteId = this.id;
      var currentSelectedId = this.sharedState.selectedRemoteId;
      // var remoteObj = {}

      if (selectedRemoteId === currentSelectedId) {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateSelectedRemoteId(0);
        // store.updateSelectedRemoteObj(remoteObj)
      } else {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateSelectedRemoteId(selectedRemoteId);
        // remoteObj = this.sharedState.remotes[parseInt(this.remoteKey)]
        // store.updateSelectedRemoteObj(remoteObj)
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].setLocalStorageRemote();
      }

      if (this.id === this.sharedState.selectedRemoteId) {
        this.active = true;
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStepValidation(true);

        // Navigate to view system, if not view select remote step
        if (this.sharedState.currentStep.id === 'selectRemote') {
          __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectUpgrades');
          __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectUpgrades' });
        }
      } else {
        this.active = false;
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStepValidation(false);
      }
    }
  },
  mounted: function mounted() {
    if (this.id === this.sharedState.selectedRemoteId) {
      this.active = true;
    } else {
      this.active = false;
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.id === this.sharedState.selectedRemoteId) {
      this.active = true;
    } else {
      this.active = false;
    }
  }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upgradeItem',
  props: ['id', 'isActive'],
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state,
      active: this.isActive,
      upgradeId: this.id
    };
  },

  methods: {
    toggleSelectedUpgrade: function toggleSelectedUpgrade() {
      var upgradeId = this.upgradeId;

      // Update store with updated attributes
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateSelectedAttribute(upgradeId);
    }
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'featureItem',
  data: function data() {
    return {
      active: false
    };
  },

  methods: {
    toggleSelected: function toggleSelected() {
      if (this.active === true) {
        this.active = false;
      } else {
        this.active = true;
      }
    },
    featureItemClicked: function featureItemClicked() {
      this.$emit('updateRemoteFilter');
      this.toggleSelected();
    }
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state,
      numberSteps: 6
    };
  },

  methods: {
    goBackStep: function goBackStep() {
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].go(-1);

      // Get ID of step going to
      var stepName = '';
      var currentStepNumber = parseInt(this.sharedState.currentStep.stepNumber);

      for (var theStep in this.sharedState.steps) {
        if (parseInt(this.sharedState.steps[theStep].stepNumber) === currentStepNumber - 1) {
          stepName = this.sharedState.steps[theStep].id;
        }
      }

      // Update to the correct state
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute(stepName);
    },
    resetBuilder: function resetBuilder() {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].resetBuilder();
    },
    subtractValues: function subtractValues() {
      return parseInt(this.numberSteps - parseInt(this.sharedState.currentStep.stepNumber));
    }
  },
  computed: {
    numberStepsIncomplete: function numberStepsIncomplete() {
      return this.subtractValues();
    }
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: ['isActive', 'name'],
  data: function data() {
    return {
      modalName: this.name,
      active: this.isActive
    };
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notification',
  props: ['isActive', 'name', 'nColor'],
  data: function data() {
    return {
      notificationName: this.name,
      active: this.isActive,
      notificationColor: this.nColor
    };
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footerNav',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state
    };
  },

  methods: {
    updateCurrentRoute: function updateCurrentRoute() {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute(__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].history.current.name);
    },
    checkButtonRequireValidation: function checkButtonRequireValidation(buttonObj) {
      if (buttonObj.requireStepValidation) {
        return true;
      } else {
        return false;
      }
    },
    handleButtonClick: function handleButtonClick(event) {
      var linkTo = event.target.attributes['data-link'].value;

      function goToStep() {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: linkTo });
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute(linkTo);
      }

      // Validation
      switch (linkTo) {
        case 'selectVehicle':
          goToStep();
          break;
        case 'selectSystem':
          if (this.sharedState.steps.selectVehicle.passedValidation) {
            goToStep();
          }
          break;
        case 'selectRemote':
          if (this.sharedState.steps.selectSystem.passedValidation) {
            goToStep();
          }
          break;
        case 'viewSystem':
          goToStep();
          break;
        case 'contactInfo':
          goToStep();
          break;
        case 'contactDealer':
          if (this.sharedState.steps.viewSystem.passedValidation) {
            goToStep();
          }
          break;
        case 'print':
          window.print();
          break;
        case '-1':
          goToStep();
          break;

        default:
      }
    },
    currentStepValidation: function currentStepValidation(requireVal) {
      if (requireVal === true) {
        if (this.sharedState.currentStep.passedValidation === false) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    this.updateCurrentRoute();
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'canadianContact',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_modal_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reusable_modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_notification_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_notification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__reusable_notification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reusable_stickyFooterNavigation_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reusable_stickyFooterNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__reusable_stickyFooterNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { footerNav: __WEBPACK_IMPORTED_MODULE_4__reusable_stickyFooterNavigation_vue___default.a, modal: __WEBPACK_IMPORTED_MODULE_2__reusable_modal_vue___default.a, spinner: __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner___default.a, notification: __WEBPACK_IMPORTED_MODULE_3__reusable_notification_vue___default.a },
  name: 'configureSystem',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state,
      options: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.selectableOptions,
      categoryModal: false,
      upgradeModal: false,
      successNotification: false,
      warningNotification: false,
      lockedMessage: false,
      offset: {
        top: 75
      }
    };
  },

  methods: {
    updateVehicleObjectState: function updateVehicleObjectState(event) {
      this.vehicleId = event.target.value;

      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateVehicleObject(this.sharedState.selectedMake, this.sharedState.selectedModel, event.target.value);
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStepValidation(true);

      // Display message depending on vehicle compatibility
      if (this.sharedState.vehicleObject.compatibleSystem === false) {
        this.successNotification = false;
        this.warningNotification = true;
      } else if (this.sharedState.vehicleObject.compatibleSystem === null || this.sharedState.vehicleObject.compatibleSystem === '') {
        this.warningNotification = false;
        this.successNotification = true;
      }
    },
    cleanArray: function cleanArray(arr) {
      return arr.filter(function (x, i) {
        return arr.indexOf(x) === i;
      });
    },
    separateYearArray: function separateYearArray(originalArray) {
      var automaticYears = [];
      var manualYears = [];
      var value;

      for (var i = 0; i < originalArray.length; i++) {
        value = originalArray[i]['trany'];

        if (value === 'Automatic') {
          automaticYears.push(originalArray[i]);
        } else {
          manualYears.push(originalArray[i]);
        }
      }

      // Send manual transmission array state
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateManualYears(manualYears);

      return automaticYears;
    },
    getVehicleMakes: function getVehicleMakes() {
      var makesArr = [];
      var vehicleMakes = this.sharedState.vehicleJson.makes[0];

      for (var i in vehicleMakes) {
        makesArr.push(i);
      }

      // Clean make array
      makesArr = this.cleanArray(makesArr);
      makesArr = makesArr.sort();

      return makesArr;
    },
    getVehicleModels: function getVehicleModels(event) {
      var makeValue = event.target.value;
      var vehicleMakes = this.sharedState.vehicleJson.makes[0];
      var modelArray = [];

      for (var i in vehicleMakes) {
        if (i === makeValue) {
          var vehicleMake = vehicleMakes[i];
          for (var x in vehicleMake) {
            modelArray.push(vehicleMakes[i][x]['model']);
          }
        }
      }

      // Strip model array of duplicate values and sort
      modelArray = this.cleanArray(modelArray);
      modelArray = modelArray.sort();

      this.sharedState.vehicleModelsData = modelArray;
    },
    getVehicleYears: function getVehicleYears(event) {
      var makeValue = this.sharedState.selectedMake;
      var modelValue = event.target.value;
      var yearArray = [];
      var vehicleMakes = this.sharedState.vehicleJson.makes[0];

      for (var i in vehicleMakes) {
        if (i === makeValue) {
          var vehicleMake = vehicleMakes[i];
          for (var x in vehicleMake) {
            if (vehicleMakes[i][x]['model'] === modelValue) {
              yearArray.push({
                year: vehicleMakes[i][x]['year'],
                id: vehicleMakes[i][x]['id'],
                trany: vehicleMakes[i][x]['trany'],
                compatibleSystem: vehicleMakes[i][x]['compatibleSystem'],
                vehicleSpecificId: vehicleMakes[i][x]['vehicleSpecificId']
              });
            }
          }
        }
      }

      // Clean duplicate year values
      yearArray = this.separateYearArray(yearArray);
      yearArray = yearArray.sort(function (a, b) {
        return b.year - a.year;
      });

      this.sharedState.vehicleYearsData = yearArray;
    },
    setSelectedCategory: function setSelectedCategory(event) {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].setCategorySelectionState(event.target.id);
    },
    updateSelectedAttribute: function updateSelectedAttribute(event) {
      if (event.target.attributes.length > 0) {
        var optionId = event.target.attributes['id'].value;
        var isLocked = this.sharedState.selectableOptions[optionId].locked;

        if (isLocked === false) {
          __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].setSelectedAttribute(event.target.id);
        } else {
          this.lockedMessage = true;
        }
      }
    },
    checkIfAttributeSelected: function checkIfAttributeSelected(optionId) {
      // check sharedState to see if current attribute is selected
      return this.sharedState.selectableOptions[optionId].selected;
    },
    getVehicleData: function getVehicleData() {
      var _this = this;

      var host = 'https://' + window.location.hostname;

      var themePath = '/wp-content/themes/compustar/javascript/';
      var jsonPath = host + themePath + 'vehicles.json';

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(jsonPath).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].holdVehicleJson(response.data);
        _this.sharedState.vehicleJson = response.data;
        _this.sharedState.vehicleMakesData = _this.getVehicleMakes();
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    if (this.sharedState.vehicleJson === null) {
      this.getVehicleData();
    }
    __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].getLocalStorage();
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { footerNav: __WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue___default.a, spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a },
  name: 'contactDealer',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state,
      mapHtml: '',
      mapData: '',
      altMap: ''
    };
  },

  methods: {
    retrieveDealers: function retrieveDealers() {
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var googleMapUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.customerDetails.customerZip + '&key=AIzaSyBOPUa1-e4k7hsf5qVHNlBr-YHtN7UUQgo';
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(googleMapUrl).then(function (response) {
        var latLon = response.data.results[0].geometry.location;
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
          url: ajaxUrl,
          type: 'POST',
          data: {
            action: 'system-builder-get-dealers',
            location: latLon
          },
          cache: false,
          dataType: 'text',
          success: function success(response) {
            var jsonObj = JSON.parse(response);
            self.mapData = jsonObj.mapData;
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateDealersState(jsonObj.stores);
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateMapState(jsonObj.mapData);
            return false;
          }
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    getMap: function getMap() {
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var self = this;

      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: {
          action: 'get-map-with-dealers',
          dealerIds: '30275, 30101, 32647, 32921, 33634, 29909, 29908'
        },
        cache: false,
        dataType: 'text',
        success: function success(response) {
          console.log(response);
          var jsonObj = JSON.parse(response);
          self.mapHtml = jsonObj;
          return false;
        }
      });
    },
    editContactForm: function editContactForm() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].changeFormValidationState(false);
    },
    prepareTelLink: function prepareTelLink(val) {
      return 'tel:' + val;
    },
    objectLength: function objectLength(object) {
      var length = 0;
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          ++length;
        }
      }
      return length;
    }
  },
  mounted: function mounted() {
    if (this.sharedState.dealers === null) {
      this.retrieveDealers();
    } else {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getLocalStorage();
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].setInquiryDataLocalStorage();
    }

    // Check if previous step has been completed before saving data
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.customerDetails.customerZip !== '') {
      // Save inquiry data to database
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var inquiryDataSavedStatus = this.sharedState.inquiryDataSaved;

      if (inquiryDataSavedStatus === false) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          data: {
            action: 'save-inquiry-data',
            data: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getStoreDataToSave()
          },
          cache: false,
          success: function success(response) {
            // var jsonObj = JSON.parse(response)
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].inquiryDataSaved();
            return false;
          }
        });
      }
    }

    this.getMap();
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_postcode_validator__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_postcode_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_postcode_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_awesome_phonenumber__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_awesome_phonenumber__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { footerNav: __WEBPACK_IMPORTED_MODULE_1__reusable_stickyFooterNavigation_vue___default.a },
  name: 'contactInfo',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state,
      showButton: false,
      showHelpMessage: false,
      showPhoneHelp: false
    };
  },

  methods: {
    checkCanadianPostal: function checkCanadianPostal(postal) {
      var canadaRegex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i);
      if (canadaRegex.test(postal)) {
        return true;
      } else {
        return false;
      }
    },
    checkFormValidation: function checkFormValidation() {
      var customerEmail = this.sharedState.customerDetails.customerEmail;
      var customerName = this.sharedState.customerDetails.customerName;
      var customerPhone = this.sharedState.customerDetails.customerPhone;
      var customerZip = this.sharedState.customerDetails.customerZip;

      var isZipValid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(customerZip);

      if (this.checkCanadianPostal(customerZip)) {
        isZipValid = true;
      }

      // Validate phone number
      if (customerPhone !== '' && customerZip !== '') {
        // If phone & zip value exists, validate phone number
        // Get country code from zip
        var isValidUS = __WEBPACK_IMPORTED_MODULE_2_postcode_validator___default.a.validate('us', customerZip);
        var isValidCA = __WEBPACK_IMPORTED_MODULE_2_postcode_validator___default.a.validate('ca', customerZip);

        var regionCode = '';

        if (isValidUS === true) {
          // Zip is from US
          regionCode = 'US';
        } else if (isValidCA === true) {
          // Zip is from CA
          regionCode = 'CA';
        }

        var pn = new __WEBPACK_IMPORTED_MODULE_3_awesome_phonenumber___default.a(customerPhone, regionCode);
        var isPhoneValid = pn.isValid();
      }

      if (customerEmail && customerName !== '' && isPhoneValid && isZipValid) {
        this.showButton = true;
        this.showHelpMessage = false;

        // Format phone number and update
        var formattedPhoneNumber = pn.getNumber('international');
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updatePhoneNumber(formattedPhoneNumber);

        this.showPhoneHelp = false;
      } else {
        if (isPhoneValid === false) {
          this.showPhoneHelp = true;
        }

        this.showButton = false;
      }
    }
  },
  mounted: function mounted() {
    this.checkFormValidation();
  },
  updated: function updated() {
    this.checkFormValidation();
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'dealerFollowup',
  props: {
    inquiryId: {
      type: String,
      default: ''
    },
    quoteId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state,
      alreadySent: false
    };
  },

  methods: {
    goToViewSystem: function goToViewSystem() {
      var currentInquiryId = this.inquiryId;
      var currentQuoteId = this.quoteId;
      // router.push({name: 'viewSystem', params: {inquiryId: currentInquiryId, quoteId: currentQuoteId}})
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/view-system/' + currentInquiryId + '/' + currentQuoteId });
    },
    adjustAlreadySentStatus: function adjustAlreadySentStatus(status) {
      this.alreadySent = status;
    }
  },
  mounted: function mounted() {
    if (this.inquiryId !== undefined && this.inquiryId !== '' && this.inquiryId.length === 45 && this.quoteId !== 0) {
      // Toggle main nav off
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].toggleMainNav();

      // Inquiry ID supplied, check against DB
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var self = this;

      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'text',
        timeout: 7000,
        data: {
          action: 'system-builder-dealer-followup',
          inquiryId: this.inquiryId,
          quoteId: this.quoteId
        },
        cache: false,
        success: function success(response) {
          console.log(response === '"Already Sent"');
          if (response === '"Already Sent"') {
            self.adjustAlreadySentStatus(true);
          }
          return false;
        }
      });
    } else {
      // If no inquiry ID supplied, do route validation
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateCurrentStateRoute('selectVehicle');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectVehicle' });
      return false;
    }
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'contactDealer',
  props: {
    inquiryId: {
      type: String,
      default: ''
    },
    quoteId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state,
      alreadySent: false
    };
  },

  methods: {},
  mounted: function mounted() {
    if (this.inquiryId !== undefined && this.inquiryId !== '' && this.inquiryId.length === 45 && this.quoteId !== 0) {
      // Toggle main nav off
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].toggleMainNav();

      // Inquiry ID supplied, check against DB
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var self = this;

      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'text',
        timeout: 7000,
        data: {
          action: 'system-builder-dealer-successful-followup',
          inquiryId: this.inquiryId,
          quoteId: this.quoteId
        },
        cache: false,
        success: function success(response) {
          if (response === '"Already Sent"') {
            self.alreadySent = true;
          }
          return false;
        }
      });
    } else {
      // If no inquiry ID supplied, do route validation
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateCurrentStateRoute('selectVehicle');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectVehicle' });
      return false;
    }
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_DealerItem_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_DealerItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reusable_DealerItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { dealerItem: __WEBPACK_IMPORTED_MODULE_2__reusable_DealerItem_vue___default.a, spinner: __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default.a },
  name: 'contactInfo',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state,
      emailButtonLoading: false,
      emailSent: false
    };
  },

  methods: {
    goBackStep: function goBackStep() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].go(-1);

      // Get ID of step going to
      var stepName = '';
      var currentStepNumber = this.sharedState.currentStep.stepNumber;

      for (var theStep in this.sharedState.steps) {
        if (this.sharedState.steps[theStep].stepNumber === currentStepNumber - 1) {
          stepName = this.sharedState.steps[theStep].id;
        }
      }

      // Update to the correct state
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateCurrentStateRoute(stepName);
    },
    editContactForm: function editContactForm() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].changeFormValidationState(false);
    },
    objectLength: function objectLength(object) {
      var length = 0;
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          ++length;
        }
      }
      return length;
    },
    checkPropForValue: function checkPropForValue(propVal) {
      // If prop value does not exist, give default value
      if (propVal === '' || propVal === undefined) {
        return false;
      } else {
        return propVal;
      }
    }
  },
  computed: {
    getNumberDealers: function getNumberDealers() {
      return this.objectLength(this.sharedState.dealers);
    }
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selectCommunicationType',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state
    };
  },

  methods: {
    setSelectedCommunication: function setSelectedCommunication(str) {
      // Save the communication type to state
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].setSelectedCommunication(str);

      // Navigate to remote selection
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectRemote');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectRemote' });
    }
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.vehicleObject.year === 'Vehicle Year') {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectVehicle');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectVehicle' });
      return false;
    } else if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.selectedSystemCategory === '') {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectCommunicationType');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectCommunicationType' });
      return false;
    }
  }
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_featureItem_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_featureItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__reusable_featureItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { remoteItem: __WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue___default.a, featureItem: __WEBPACK_IMPORTED_MODULE_3__reusable_featureItem_vue___default.a },
  name: 'selectRemote',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state,
      numberFeaturesToShow: 3
    };
  },

  methods: {
    objectLength: function objectLength(object) {
      var length = 0;
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          ++length;
        }
      }
      return length;
    },
    containsObject: function containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i] === obj) {
          return true;
        }
      }

      return false;
    },
    retrieveAccessories: function retrieveAccessories() {
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'text',
        data: {
          action: 'system-builder-get-accessories'
        },
        cache: false,
        success: function success(response) {
          var jsonObj = JSON.parse(response);
          __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].holdAccessories(jsonObj.accessories);
          return false;
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.sharedState.accessories === null) {
      this.retrieveAccessories();
    }
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.vehicleObject.year === 'Vehicle Year') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateCurrentStateRoute('selectVehicle');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectVehicle' });
      return false;
    } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.selectedSystemCategory === '') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateCurrentStateRoute('selectSystem');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectSystem' });
      return false;
    } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.selectedCommunication === '') {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateCurrentStateRoute('selectCommunicationType');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectCommunicationType' });
      return false;
    }
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getLocalStorage();
  }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a },
  name: 'selectSystem',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state
    };
  },

  methods: {
    saveSelectedSystem: function saveSelectedSystem(selectedSystem) {
      // Save selected system in store
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].holdSelectedSystem(selectedSystem);

      // Create system string and store in state
      var systemCatString = '';

      if (selectedSystem === 'START IT') {
        systemCatString = 'Universal Remote Start System';
      } else if (selectedSystem === 'ALARM IT') {
        systemCatString = 'Universal Security System';
      } else if (selectedSystem === 'MAX IT') {
        systemCatString = 'Universal Remote Start & Security System';
      }

      var systemString = systemCatString;
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateSystemStringState(systemString);

      // Navigate to remote selection
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectCommunication');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectCommunicationType' });
    }
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.vehicleObject.year === 'Vehicle Year') {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectVehicle');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectVehicle' });
      return false;
    }
  }
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_UpgradeItem_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_UpgradeItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reusable_UpgradeItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { footerNav: __WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue___default.a, upgradeItem: __WEBPACK_IMPORTED_MODULE_2__reusable_UpgradeItem_vue___default.a },
  name: 'selectUpgrades',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state
    };
  },

  methods: {
    goToViewSystem: function goToViewSystem() {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('viewSystem');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'viewSystem' });
    },
    checkCompatibility: function checkCompatibility(modelNumber) {
      if (this.sharedState.vehicleObject.vehicleSpecificId && modelNumber === 'FT-EZ GO') {
        return false;
      } else if (this.sharedState.selectedRemote.ID === 38117 && modelNumber === 'DR-3400') {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.vehicleObject.year === 'Vehicle Year') {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectVehicle');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectVehicle' });
      return false;
    } else if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.selectedSystemCategory === '') {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectSystem');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectSystem' });
      return false;
    } else if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.selectedCommunication === '') {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectCommunicationType');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectCommunicationType' });
      return false;
    } else if (!__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.selectedRemote) {
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectRemote');
      __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */].push({ name: 'selectRemote' });
      return false;
    }
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].getLocalStorage();
  }
});

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a, footerNav: __WEBPACK_IMPORTED_MODULE_3__reusable_stickyFooterNavigation_vue___default.a },
  name: 'selectVehicle',
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state,
      successNotification: false,
      warningNotification: false
    };
  },

  methods: {
    // TODO: Loading on button if remote request is still in progress

    updateVehicleObjectState: function updateVehicleObjectState(event) {
      this.vehicleId = event.target.value;

      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateVehicleObject(this.sharedState.selectedMake, this.sharedState.selectedModel, event.target.value);
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStepValidation(true);

      // Display message depending on vehicle compatibility
      if (this.sharedState.vehicleObject.compatibleSystem === false || this.sharedState.vehicleObject.compatibleSystem === 'FALSE') {
        this.successNotification = false;
        this.warningNotification = true;
      } else if (this.sharedState.vehicleObject.compatibleSystem === null || this.sharedState.vehicleObject.compatibleSystem === '') {
        this.warningNotification = false;
        this.successNotification = true;
      }
    },
    cleanArray: function cleanArray(arr) {
      return arr.filter(function (x, i) {
        return arr.indexOf(x) === i;
      });
    },
    separateYearArray: function separateYearArray(originalArray) {
      var automaticYears = [];
      var manualYears = [];
      var value;

      for (var i = 0; i < originalArray.length; i++) {
        value = originalArray[i]['trany'];

        if (value === 'Automatic') {
          automaticYears.push(originalArray[i]);
        } else {
          manualYears.push(originalArray[i]);
        }
      }

      // Send manual transmission array state
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateManualYears(manualYears);

      return automaticYears;
    },
    getVehicleMakes: function getVehicleMakes() {
      var makesArr = [];
      var vehicleMakes = this.sharedState.vehicleJson.makes[0];

      for (var i in vehicleMakes) {
        makesArr.push(i);
      }

      // Clean make array
      makesArr = this.cleanArray(makesArr);
      makesArr = makesArr.sort();

      return makesArr;
    },
    getVehicleModels: function getVehicleModels(event) {
      var makeValue = event.target.value;
      var vehicleMakes = this.sharedState.vehicleJson.makes[0];
      var modelArray = [];

      for (var i in vehicleMakes) {
        if (i === makeValue) {
          var vehicleMake = vehicleMakes[i];
          for (var x in vehicleMake) {
            modelArray.push(vehicleMakes[i][x]['model']);
          }
        }
      }

      // Strip model array of duplicate values and sort
      modelArray = this.cleanArray(modelArray);
      modelArray = modelArray.sort();

      // Set Year data to empty array
      this.sharedState.vehicleYearsData = [];

      // Remove selected year
      this.sharedState.selectedYear = 'Vehicle Year';
      this.sharedState.selectedYearValue = 'Vehicle Year';
      this.sharedState.vehicleObject.year = 'Vehicle Year';

      // Remove selected model
      this.sharedState.selectedModel = 'Vehicle Model';

      this.sharedState.vehicleModelsData = modelArray;
    },
    getVehicleYears: function getVehicleYears(event) {
      var makeValue = this.sharedState.selectedMake;
      var modelValue = event.target.value;
      var yearArray = [];
      var vehicleMakes = this.sharedState.vehicleJson.makes[0];

      for (var i in vehicleMakes) {
        if (i === makeValue) {
          var vehicleMake = vehicleMakes[i];
          for (var x in vehicleMake) {
            if (vehicleMakes[i][x]['model'] === modelValue) {
              yearArray.push({
                year: vehicleMakes[i][x]['year'],
                id: vehicleMakes[i][x]['id'],
                trany: vehicleMakes[i][x]['trany'],
                compatibleSystem: vehicleMakes[i][x]['compatibleSystem'],
                vehicleSpecificId: vehicleMakes[i][x]['vehicleSpecificId']
              });
            }
          }
        }
      }

      // Clean duplicate year values
      yearArray = this.separateYearArray(yearArray);
      yearArray = yearArray.sort(function (a, b) {
        return b.year - a.year;
      });

      this.sharedState.vehicleYearsData = yearArray;
    },
    getVehicleData: function getVehicleData() {
      var _this = this;

      var host = 'https://' + window.location.hostname;
      var themePath = '/wp-content/themes/arcticstart_ch/javascript/';

      var jsonPath = host + themePath + 'vehicles.json';

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(jsonPath).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].holdVehicleJson(response.data);
        _this.sharedState.vehicleJson = response.data;
        _this.sharedState.vehicleMakesData = _this.getVehicleMakes();
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    if (this.sharedState.vehicleJson === null) {
      this.getVehicleData();
    }
    __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].getLocalStorage();
  }
});

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'thankYou',
  props: {
    inquiryId: {
      type: String,
      default: ''
    },
    quoteId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state,
      alreadySent: false
    };
  },

  methods: {
    goToViewSystem: function goToViewSystem() {
      var currentInquiryId = this.inquiryId;
      var currentQuoteId = this.quoteId;
      // router.push({name: 'viewSystem', params: {inquiryId: currentInquiryId, quoteId: currentQuoteId}})
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: '/view-system/' + currentInquiryId + '/' + currentQuoteId });
    }
  },
  mounted: function mounted() {
    if (this.inquiryId !== undefined && this.inquiryId !== '' && this.inquiryId.length === 45 && this.quoteId !== 0) {
      // Toggle main nav off
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].toggleMainNav();

      // Inquiry ID supplied, check against DB
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var self = this;

      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'text',
        timeout: 7000,
        data: {
          action: 'system-builder-dealer-successful-followup',
          inquiryId: this.inquiryId,
          quoteId: this.quoteId
        },
        cache: false,
        success: function success(response) {
          if (response === '"Already Sent"') {
            self.alreadySent = true;
          }
          return false;
        }
      });
    } else {
      // If no inquiry ID supplied, do route validation
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].updateCurrentStateRoute('selectVehicle');
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectVehicle' });
      return false;
    }
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CanadianContact_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CanadianContact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CanadianContact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactInfo_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ContactInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DealerList_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DealerList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DealerList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { remoteItem: __WEBPACK_IMPORTED_MODULE_2__reusable_RemoteItem_vue___default.a, canadianContact: __WEBPACK_IMPORTED_MODULE_3__CanadianContact_vue___default.a, contactInfo: __WEBPACK_IMPORTED_MODULE_4__ContactInfo_vue___default.a, dealerList: __WEBPACK_IMPORTED_MODULE_5__DealerList_vue___default.a },
  name: 'viewSystem',
  props: {
    inquiryId: {
      type: String,
      default: ''
    },
    quoteId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state,
      formPassedValidation: false,
      isCanadianPostCode: false
    };
  },

  methods: {
    printSystem: function printSystem() {
      window.print();
    },
    checkCanadianPostal: function checkCanadianPostal(postal) {
      var canadaRegex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i);
      if (canadaRegex.test(postal)) {
        return true;
      } else {
        return false;
      }
    },

    checkFormValidation: function checkFormValidation() {
      var customerZip = this.sharedState.customerDetails.customerZip;

      if (this.checkCanadianPostal(customerZip)) {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].changeFormValidationState(true);
        this.formPassedValidation = true;
        this.isCanadianPostCode = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].changeFormValidationState(true);
        this.formPassedValidation = true;
      }
    },
    retrieveDealers: function retrieveDealers() {
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var googleMapUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.customerDetails.customerZip + '&key=AIzaSyBOPUa1-e4k7hsf5qVHNlBr-YHtN7UUQgo';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(googleMapUrl).then(function (response) {
        var latLon = response.data.results[0].geometry.location;
        __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.ajax({
          url: ajaxUrl,
          type: 'POST',
          data: {
            action: 'system-builder-get-dealers',
            location: latLon
          },
          cache: false,
          dataType: 'text',
          success: function success(response) {
            var jsonObj = JSON.parse(response);
            __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateDealersState(jsonObj.stores);
            return false;
          }
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    submitInquiryData: function submitInquiryData() {
      // Save inquiry data to database
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      var inquiryDataSavedStatus = this.sharedState.inquiryDataSaved;

      if (inquiryDataSavedStatus === false) {
        __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          timeout: 7000,
          data: {
            action: 'save-inquiry-data',
            data: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].getStoreDataToSave(),
            stateObject: __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].getStateObj()
          },
          cache: false,
          success: function success(response) {
            var jsonObj = JSON.parse(response);
            __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].inquiryDataSaved(jsonObj);
            return false;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.inquiryId !== undefined && this.inquiryId !== '' && this.inquiryId.length === 45 && this.quoteId !== 0) {
      // Toggle main nav off
      __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].toggleMainNav();

      // Inquiry ID supplied, check against DB
      var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php';

      __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'text',
        timeout: 7000,
        data: {
          action: 'system-builder-get-inquiry-data',
          inquiryId: this.inquiryId,
          quoteId: this.quoteId
        },
        cache: false,
        success: function success(response) {
          var jsonObj = JSON.parse(response);
          __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateStateWithData(jsonObj);
          return false;
        }
      });
    } else {
      // If no inquiry ID supplied, do route validation
      if (__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.vehicleObject.year === 'Vehicle Year') {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectVehicle');
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectVehicle' });
        return false;
      } else if (!__WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].state.selectedRemote) {
        __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].updateCurrentStateRoute('selectRemote');
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'selectRemote' });
        return false;
      }
    }
  },
  computed: {
    compatibilityMessage: function compatibilityMessage() {
      // Display message depending on vehicle compatibility
      if (this.sharedState.vehicleObject.compatibleSystem === false) {
        return this.sharedState.customFields.not_compatible_message_title;
      } else if (this.sharedState.vehicleObject.compatibleSystem === null || this.sharedState.vehicleObject.compatibleSystem === '') {
        return this.sharedState.customFields.data_compatible_message_title;
      } else {
        return this.sharedState.customFields.data_compatible_message_title;
      }
    },
    systemString: function systemString() {
      if (this.sharedState.vehicleObject.vehicleSpecificId !== '') {
        return this.sharedState.selectedSystem.post_title;
      } else {
        return this.sharedState.systemString;
      }
    },
    customerZip: function customerZip() {
      return this.sharedState.customerDetails.customerZip;
    },
    validZip: function validZip() {
      var isZipValid = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.sharedState.customerDetails.customerZip);
      return isZipValid;
    }
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_0__store_index__["a" /* default */].getLocalStorage();
  },
  watch: {
    formPassedValidation: function formPassedValidation() {
      // Only run if formPassedValidation is true
      if (this.formPassedValidation) {
        this.retrieveDealers();
        this.submitInquiryData();
      }
    },
    customerZip: function customerZip() {
      // Only run if formPassedValidation is true
      if (this.formPassedValidation && this.validZip) {
        this.retrieveDealers();
      }
    }
  }
});

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(418),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(431),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(419),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(433),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(415),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(427),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(424),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(413),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__select-system--container"
  }, [_c('div', {
    staticClass: "system-builder__select-system--item"
  }, [(_vm.sharedState.customFields.remote_start_image) ? _c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.remote_start_image.url,
      "alt": _vm.sharedState.customFields.remote_start_image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.remote_start_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.remote_start_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.saveSelectedSystem('START IT')
      }
    }
  }, [_vm._v("Select")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__select-system--item"
  }, [(_vm.sharedState.customFields.security_image) ? _c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.security_image.url,
      "alt": _vm.sharedState.customFields.security_image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.security_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.security_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.saveSelectedSystem('ALARM IT')
      }
    }
  }, [_vm._v("Select")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__select-system--item"
  }, [(_vm.sharedState.customFields.remote_start_security_image) ? _c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.remote_start_security_image.url,
      "alt": _vm.sharedState.customFields.remote_start_security_image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.remote_start_security_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.remote_start_security_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.saveSelectedSystem('MAX IT')
      }
    }
  }, [_vm._v("Select")])])])
},staticRenderFns: []}

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__contact-dealer--section"
  }, [_c('div', {
    staticClass: "system-builder__main-container"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--main-container"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container"
  }, [_c('div', {
    staticClass: "system-builder__main-container--header"
  }, [_c('h2', [_vm._v("Get a Quote from Your Local Dealer!")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.editContactForm
    }
  }, [_vm._v("Edit Contact Info")])]), _vm._v(" "), (_vm.sharedState.dealers === null) ? _c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container-alt"
  }, [_c('spinner', {
    attrs: {
      "size": "large",
      "message": "Loading dealers nearby..."
    }
  })], 1) : _c('div', {
    staticClass: "system-builder__contact-dealer--dealer-items-container"
  }, _vm._l((_vm.sharedState.dealers), function(dealer, index) {
    return _c('div', {
      key: dealer.ID,
      staticClass: "system-builder__contact-dealer--dealer-item"
    }, [_c('div', {
      staticClass: "system-builder__contact-dealer--dealer-content"
    }, [_c('div', {
      staticClass: "dealer-details"
    }, [_c('h5', [_vm._v(_vm._s(dealer.post_title))]), _vm._v(" "), _c('p', [_vm._v("\n                  " + _vm._s(dealer.custom_fields.wpsl_address[0])), _c('br'), _vm._v("\n                  " + _vm._s(dealer.custom_fields.wpsl_city[0]) + ", " + _vm._s(dealer.custom_fields.wpsl_state[0]) + " " + _vm._s(dealer.custom_fields.wpsl_zip[0]) + "\n                ")])]), _vm._v(" "), (dealer.custom_fields.tx_wpsl_store_category[0] === 'PRO') ? _c('div', {
      staticClass: "pro-logo"
    }, [_c('img', {
      attrs: {
        "src": "",
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__contact-dealer--dealer-cta-container"
    }, [_c('div', {
      staticClass: "button__outline--primary"
    }, [_c('a', {
      attrs: {
        "href": _vm.prepareTelLink(dealer.custom_fields.wpsl_phone[0])
      }
    }, [_vm._v("Call")])]), _vm._v(" "), (dealer.custom_fields.wpsl_email[0]) ? _c('div', {
      staticClass: "button__solid--blue"
    }, [_vm._v("Get E-Quote")]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: " system-builder__contact-dealer--system-container"
  }, [_c('div', {
    staticClass: "system-builder__main-container--content"
  }, [_c('div', {
    staticClass: "system-builder__view-system--main-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--system-container"
  }, [_vm._m(0), _vm._v(" "), (_vm.sharedState.selectedSystem) ? _c('div', {
    staticClass: "system-builder__view-system--system-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedSystem.images[0].image.url,
      "alt": _vm.sharedState.selectedSystem.images[0].image.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--system-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sharedState.systemString))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.sharedState.selectedSystem.subtitle))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.selectedSystem.description)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--addon-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--remote-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item"
  }, [_c('div', {
    staticClass: "system-builder__remotes--item-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedRemote.images[0].image.url,
      "alt": _vm.sharedState.selectedRemote.images[0].image.alt
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.sharedState.selectedRemote.post_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.sharedState.selectedRemote.remote_features), function(feature, featureIndex) {
    return (featureIndex < 3) ? _c('li', [_vm._v(_vm._s(feature) + "\n                      ")]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--upgrades-container"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.sharedState.selectedUpgrades), function(upgrade) {
    return _c('div', {
      staticClass: "system-builder__upgrades--item"
    }, [_c('div', {
      staticClass: "system-builder__upgrades--item-image"
    }, [_c('img', {
      attrs: {
        "src": upgrade.images[0].image.url,
        "alt": upgrade.images[0].image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__upgrades--item-content"
    }, [_c('h4', [_vm._v(_vm._s(upgrade.post_title))]), _vm._v(" "), _c('ul', _vm._l((upgrade.features), function(feature) {
      return (upgrade.features) ? _c('li', [_vm._v(_vm._s(feature))]) : _vm._e()
    }))])])
  })], 2)])])])])])]), _vm._v(" "), _c('footerNav')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your System")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Remote")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Upgrades")])])
}]}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.isActive) ? _c('div', {
    staticClass: "system-builder__notification",
    style: ({
      border: '3px solid ' + _vm.notificationColor
    }),
    on: {
      "click": function($event) {
        {
          _vm.$emit('closeNotification')
        }
      }
    }
  }, [_c('div', {
    staticClass: "system-builder__notification--content"
  }, [_vm._t("notification-body"), _vm._v(" "), _c('span', {
    staticClass: "system-builder__notification--close",
    on: {
      "click": _vm.closeNotification
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__select-remote--section"
  }, [_c('div', {
    staticClass: "system-builder__main-remotes--wrapper"
  }, _vm._l((_vm.sharedState.filteredRemotes), function(remote, index) {
    return _c('remoteItem', {
      attrs: {
        "remoteKey": index,
        "id": remote.ID
      }
    }, [(remote.images) ? _c('div', {
      slot: "remote-image"
    }, [_c('img', {
      attrs: {
        "src": remote.images.image.url,
        "alt": remote.images.image.alt
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      slot: "remote-description"
    }, [_c('h3', [_vm._v(_vm._s(remote.post_title))]), _vm._v(" "), _c('ul', {
      staticClass: "product-available-features"
    }, _vm._l((remote.remote_features), function(feature, featureIndex) {
      return (featureIndex < _vm.numberFeaturesToShow) ? _c('li', {
        domProps: {
          "innerHTML": _vm._s(feature)
        }
      }) : _vm._e()
    }))])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "system-builder__header--section"
  }, [_c('h2', [_vm._v(_vm._s(_vm.sharedState.currentStep.title))]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__header--progress-container"
  }, [_c('ol', {
    staticClass: "progress"
  }, [_vm._l((parseInt(_vm.sharedState.currentStep.stepNumber)), function(dot) {
    return _c('li', {
      staticClass: "is-active",
      attrs: {
        "data-step": ""
      }
    })
  }), _vm._v(" "), _vm._l((_vm.numberStepsIncomplete), function(step) {
    return _c('li', {
      attrs: {
        "data-step": ""
      }
    })
  })], 2)]), _vm._v(" "), (_vm.sharedState.currentStep.stepNumber > 1) ? _c('span', {
    staticClass: "system-builder__header--back-button",
    on: {
      "click": _vm.goBackStep
    }
  }, [_vm._v("< Back")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.sharedState.currentStep.stepNumber) > 1) ? _c('div', {
    staticClass: "system-builder__quick-nav"
  }, [_c('span', {
    on: {
      "click": _vm.resetBuilder
    }
  }, [_vm._v("Start Over")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__root",
    style: ({
      paddingBottom: _vm.navHeight
    }),
    attrs: {
      "id": "app"
    }
  }, [(_vm.sharedState.showMainNav) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('headerNav')], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slider-fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-upgrades--item",
    class: {
      'selected-upgrade': _vm.isActive
    },
    on: {
      "click": _vm.toggleSelectedUpgrade
    }
  }, [_c('div', {
    staticClass: "system-builder__main-upgrades--item-image"
  }, [_vm._t("upgrade-image")], 2), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-upgrades--item-content"
  }, [_vm._t("upgrade-description")], 2), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-upgrades--item-status",
    class: {
      'upgrade-selected-status': _vm.isActive
    }
  }, [(_vm.isActive) ? _c('span', [_vm._v("Selected")]) : _c('span', [_vm._v("Unselected")])])])
},staticRenderFns: []}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__configure-system--vehicle-container"
  }, [_c('p', [_vm._v("What is your vehicle's year, make and model?")]), _vm._v(" "), (_vm.sharedState.vehicleMakesData.length < 1) ? _c('div', [_c('spinner', {
    attrs: {
      "size": "large",
      "message": "Loading Vehicle list..."
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedMake),
      expression: "sharedState.selectedMake"
    }],
    ref: "makesSelection",
    attrs: {
      "id": "vehicle-make",
      "name": "vehicle-make"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedMake = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getVehicleModels]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedMake
    }
  }, [_vm._v(_vm._s(_vm.sharedState.selectedMake))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleMakesData), function(make) {
    return _c('option', {
      domProps: {
        "value": make
      }
    }, [_vm._v(_vm._s(make))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedModel),
      expression: "sharedState.selectedModel"
    }],
    attrs: {
      "id": "vehicle-model",
      "name": "vehicle-model"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getVehicleYears]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedModel
    }
  }, [_vm._v(_vm._s(_vm.sharedState.selectedModel))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleModelsData), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedYear),
      expression: "sharedState.selectedYear"
    }],
    attrs: {
      "id": "vehicle-year",
      "name": "vehicle-year",
      "data-id": _vm.sharedState.selectedYear
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateVehicleObjectState]
    }
  }, [_c('option', {
    attrs: {
      "data-year": _vm.sharedState.selectedYearValue,
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedYear
    }
  }, [_vm._v("\n          " + _vm._s(_vm.sharedState.vehicleObject.year) + "\n        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleYearsData), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.year))])
  })], 2)])]), _vm._v(" "), (_vm.successNotification) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "vehicle-compatible-message"
  }, [_vm._v("\n      Your vehicle is compatible!\n    ")])]) : (_vm.warningNotification) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm._v(">\n    "), _c('div', {
    staticClass: "vehicle-incompatible-message"
  }, [_c('strong', [_vm._v("Your vehicle may not be compatible.")]), _vm._v(" "), _c('p', [_vm._v("We recommend contacting your local retailer.")])])]) : _vm._e(), _vm._v(" "), (_vm.sharedState.showVehicleContinueButton === false) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('spinner', {
    attrs: {
      "size": "medium",
      "message": "Loading system components..."
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sharedState.steps.selectVehicle.passedValidation && _vm.sharedState.showVehicleContinueButton) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('footerNav')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__thank-you--section"
  }, [(_vm.alreadySent === false) ? _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("Thank you for reaching out to the customer.")]), _vm._v(" "), _c('p', [_vm._v("Hope you enjoy your install.")])]) : _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("This request is closed")]), _vm._v(" "), _c('p', [_vm._v("Thank you for reaching out to the customer.")])])])
},staticRenderFns: []}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-remotes--item",
    class: {
      'selected-remote': _vm.active
    },
    on: {
      "click": _vm.toggleSelected
    }
  }, [_c('div', {
    staticClass: "system-builder__main-remotes--item-image"
  }, [_vm._t("remote-image")], 2), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-remotes--item-content"
  }, [_vm._t("remote-description")], 2), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue"
  }, [_vm._v("Select")])])
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__contact-info--section"
  }, [_c('div', {
    staticClass: "system-builder__contact-info--container"
  }, [_c('h4', [_vm._v("Submit the form below to find and get a quote from a local dealer!")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.customerDetails.customerName),
      expression: "sharedState.customerDetails.customerName"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "name": "full-name",
      "maxlength": "70",
      "placeholder": "Full Name*",
      "onchange": "this.className=(this.value=='')?'':'visited'",
      "required": ""
    },
    domProps: {
      "value": (_vm.sharedState.customerDetails.customerName)
    },
    on: {
      "focus": _vm.toggleNav,
      "blur": _vm.toggleNav,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sharedState.customerDetails.customerName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.customerDetails.customerEmail),
      expression: "sharedState.customerDetails.customerEmail"
    }],
    attrs: {
      "type": "email",
      "value": "",
      "maxlength": "70",
      "placeholder": "Email*",
      "name": "user-email",
      "onchange": "this.className=(this.value=='')?'':'visited'",
      "required": ""
    },
    domProps: {
      "value": (_vm.sharedState.customerDetails.customerEmail)
    },
    on: {
      "focus": _vm.toggleNav,
      "blur": _vm.toggleNav,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sharedState.customerDetails.customerEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.customerDetails.customerZip),
      expression: "sharedState.customerDetails.customerZip"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "maxlength": "20",
      "placeholder": "Zip Code*",
      "name": "user-zip",
      "onchange": "this.className=(this.value=='')?'':'visited'",
      "required": ""
    },
    domProps: {
      "value": (_vm.sharedState.customerDetails.customerZip)
    },
    on: {
      "focus": _vm.toggleNav,
      "blur": _vm.toggleNav,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sharedState.customerDetails.customerZip = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showPhoneHelp) ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "14px"
    }
  }, [_vm._v("Please enter a valid phone number, including the area code.")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.customerDetails.customerPhone),
      expression: "sharedState.customerDetails.customerPhone"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "maxlength": "30",
      "placeholder": "Phone* (with area code)",
      "name": "user-phone",
      "onchange": "this.className=(this.value=='')?'':'visited'",
      "required": ""
    },
    domProps: {
      "value": (_vm.sharedState.customerDetails.customerPhone)
    },
    on: {
      "focus": _vm.toggleNav,
      "blur": _vm.toggleNav,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sharedState.customerDetails.customerPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "system-builder__contact-info--cta-container"
  }, [(_vm.showHelpMessage) ? _c('span', {
    staticClass: "contact-form-help-message"
  }, [_vm._v("*Complete required fields.")]) : _vm._e(), _vm._v(" "), (_vm.showButton) ? _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        {
          _vm.$emit('submitContactForm')
        }
      }
    }
  }, [_vm._v("Find a Dealer")]) : _c('button', {
    staticClass: "button__outline--disabled",
    on: {
      "click": function($event) {
        _vm.showHelpMessage = true
      }
    }
  }, [_vm._v("Find a Dealer")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__contact-dealer--scroll-wrap"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--final-nav"
  }, [_c('span', {
    on: {
      "click": _vm.editContactForm
    }
  }, [_vm._v("Edit Contact Info")])]), _vm._v(" "), _c('h4', [(_vm.sharedState.dealers === null) ? _c('span', [_vm._v("Submit the form below to find and get a quote from a local dealer!")]) : (_vm.getNumberDealers === 1) ? _c('span', {
    staticClass: "system-builder__dealer-count"
  }, [_vm._v("\n        Great! There is 1 dealer near " + _vm._s(_vm.sharedState.customerDetails.customerZip) + ".\n      ")]) : (_vm.getNumberDealers === 0) ? _c('span', {
    staticClass: "system-builder__dealer-count"
  }, [_vm._v("\n        Sorry, there are no dealers located near" + _vm._s(_vm.sharedState.customerDetails.customerZip) + ".\n      ")]) : _c('span', {
    staticClass: "system-builder__dealer-count"
  }, [_vm._v("\n        Great! There are " + _vm._s(_vm.getNumberDealers) + " dealers near " + _vm._s(_vm.sharedState.customerDetails.customerZip) + ".\n      ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_vm._v("Call, visit, or request an e-quote to get more information from your local dealer.")]), _vm._v(" "), (_vm.sharedState.dealers === null) ? _c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container-alt"
  }, [_c('spinner', {
    attrs: {
      "size": "large",
      "message": "Loading dealers nearby..."
    }
  })], 1) : _c('div', {
    staticClass: "system-builder__contact-dealer--dealer-items-container"
  }, _vm._l((_vm.sharedState.dealers), function(dealer, index) {
    return _c('dealerItem', {
      key: dealer.ID,
      attrs: {
        "dealerId": dealer.ID,
        "dealerPro": dealer.custom_fields.tx_wpsl_store_category[0],
        "dealerPhone": _vm.checkPropForValue(dealer.custom_fields.wpsl_phone[0]),
        "dealerEmail": dealer.custom_fields.wpsl_email[0]
      }
    }, [_c('div', {
      slot: "dealer-details"
    }, [_c('h5', [_vm._v(_vm._s(dealer.post_title) + " - "), _c('span', {
      staticClass: "system-builder__dealer-distance"
    }, [_vm._v(_vm._s(dealer.distance) + " Miles")])]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(dealer.custom_fields.wpsl_address[0])), _c('br'), _vm._v("\n            " + _vm._s(dealer.custom_fields.wpsl_city[0]) + ", " + _vm._s(dealer.custom_fields.wpsl_state[0]) + " " + _vm._s(dealer.custom_fields.wpsl_zip[0])), _c('br'), _vm._v(" "), (_vm.checkPropForValue !== false) ? _c('span', [_vm._v(_vm._s(dealer.custom_fields.wpsl_phone[0]))]) : _vm._e()])])])
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--section"
  }, [_c('div', {
    staticClass: "system-builder__main-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--main-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--complete-system-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--system-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your System")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.printSystem
    }
  }, [_vm._v("PRINT")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--system-complete"
  }, [(_vm.sharedState.selectedSystem.images) ? _c('div', {
    staticClass: "system-builder__view-system--system-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedSystem.images.image.url,
      "alt": _vm.sharedState.selectedSystem.images.image.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--system-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.systemString))]), _vm._v(" "), _c('ul', [(_vm.sharedState.vehicleObject.vehicleSpecificId !== '' && _vm.sharedState.security === false) ? _c('li', [_vm._v("T-harness: " + _vm._s(_vm.sharedState.vehicleObject.vehicleSpecificId))]) : _c('li', [_vm._v(_vm._s(_vm.sharedState.selectedSystem.model_number))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.sharedState.selectedMake) + " / " + _vm._s(_vm.sharedState.selectedModel) + " / " + _vm._s(_vm.sharedState.selectedYearValue) + "\n                ")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.compatibilityMessage))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.selectedSystem.description)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--addon-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--remote-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item"
  }, [(_vm.sharedState.selectedRemote.images) ? _c('div', {
    staticClass: "system-builder__remotes--item-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedRemote.images.image.url,
      "alt": _vm.sharedState.selectedRemote.images.image.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.sharedState.selectedRemote.post_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.sharedState.selectedRemote.remote_features_text), function(feature, featureIndex) {
    return (featureIndex < 3) ? _c('li', {
      domProps: {
        "innerHTML": _vm._s(feature)
      }
    }) : _vm._e()
  }))])])]), _vm._v(" "), (_vm.sharedState.selectedUpgrades !== undefined && _vm.sharedState.selectedUpgrades.length > 0) ? _c('div', {
    staticClass: "system-builder__view-system--upgrades-container"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.sharedState.selectedUpgrades), function(upgrade) {
    return _c('div', {
      staticClass: "system-builder__upgrades--item"
    }, [_c('div', {
      staticClass: "system-builder__upgrades--item-image"
    }, [_c('img', {
      attrs: {
        "src": upgrade.images.image.url,
        "alt": upgrade.images.image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__upgrades--item-content"
    }, [_c('h4', [_vm._v(_vm._s(upgrade.post_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(upgrade.subtitle))])])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--contact-container"
  }, [(_vm.sharedState.formPassedValidation === false) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('contactInfo', {
    on: {
      "submitContactForm": _vm.checkFormValidation
    }
  })], 1) : (_vm.isCanadianPostCode) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('canadianContact')], 1) : _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('dealerList')], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-container--header"
  }, [_c('h2', [_vm._v("Get a Quote from Your Local Dealer!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Remote")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Upgrades")])])
}]}

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "system-builder__select-communication--container"
  }, [_c('div', {
    staticClass: "system-builder__select-communication--item"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.two_way_image.url,
      "alt": _vm.sharedState.customFields.two_way_image.alt
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.two_way_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.two_way_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.setSelectedCommunication('2-way')
      }
    }
  }, [_vm._v("Select")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__select-communication--item"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.one_way_image.url,
      "alt": _vm.sharedState.customFields.one_way_image.alt
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.one_way_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.one_way_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.setSelectedCommunication('1-way')
      }
    }
  }, [_vm._v("Select")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__configure-system--section",
    attrs: {
      "sticky-container": ""
    }
  }, [_c('div', {
    staticClass: "system-builder__system-container"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky"
    }],
    attrs: {
      "sticky-offset": "offset",
      "sticky-side": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "/live/wp-content/themes/compustar/images/module-family.png",
      "alt": "Compustar systems family"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-container--content"
  }, [_c('div', {
    staticClass: "system-builder__configure-system--vehicle-container"
  }, [_c('h3', [_vm._v("1) Enter Your Vehicle")]), _vm._v(" "), _c('p', [_vm._v("What is your vehicle's year, make and model?")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.sharedState.vehicleMakesData.length < 1) ? _c('div', [_c('spinner', {
    attrs: {
      "size": "large",
      "message": "Loading Vehicle list..."
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedMake),
      expression: "sharedState.selectedMake"
    }],
    ref: "makesSelection",
    attrs: {
      "id": "vehicle-make",
      "name": "vehicle-make"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedMake = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getVehicleModels]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedMake
    }
  }, [_vm._v(_vm._s(_vm.sharedState.selectedMake))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleMakesData), function(make) {
    return _c('option', {
      domProps: {
        "value": make
      }
    }, [_vm._v(_vm._s(make))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedModel),
      expression: "sharedState.selectedModel"
    }],
    attrs: {
      "id": "vehicle-model",
      "name": "vehicle-model"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getVehicleYears]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedModel
    }
  }, [_vm._v(_vm._s(_vm.sharedState.selectedModel))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleModelsData), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedYear),
      expression: "sharedState.selectedYear"
    }],
    attrs: {
      "id": "vehicle-year",
      "name": "vehicle-year",
      "data-id": _vm.sharedState.selectedYear
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateVehicleObjectState]
    }
  }, [_c('option', {
    attrs: {
      "data-year": _vm.sharedState.selectedYearValue,
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedYear
    }
  }, [_vm._v(_vm._s(_vm.sharedState.vehicleObject.year))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleYearsData), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.year))])
  })], 2)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-container"
  }, [_c('h3', [_vm._v("2) Choose Your System")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.categoryModal = true
      }
    }
  }, [_vm._v("Which system is right for you?")]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-option",
    class: {
      'system-builder__configure-system--system-option-selected': _vm.sharedState.remoteStart
    },
    attrs: {
      "id": "remoteStart"
    },
    on: {
      "click": _vm.setSelectedCategory
    }
  }, [_vm._v("\n          I want to remote start my car.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-option",
    class: {
      'system-builder__configure-system--system-option-selected': _vm.sharedState.security
    },
    attrs: {
      "id": "security"
    },
    on: {
      "click": _vm.setSelectedCategory
    }
  }, [_vm._v("\n          I want to secure my car.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-option",
    class: {
      'system-builder__configure-system--system-option-selected': _vm.sharedState.remoteStartSecurity
    },
    attrs: {
      "id": "remoteStartSecurity"
    },
    on: {
      "click": _vm.setSelectedCategory
    }
  }, [_vm._v("\n          I want to remote start & secure my car.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--upgrade-container"
  }, [_c('h3', [_vm._v("3) Optional System Upgrades")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.upgradeModal = true
      }
    }
  }, [_vm._v("Which upgrades are right for you?")]), _vm._v(" "), _vm._l((_vm.options), function(currentOption) {
    return _c('div', {
      key: currentOption.id,
      staticClass: "system-builder__configure-system--upgrade-option",
      class: {
        'system-builder__configure-system--upgrade-option-selected': _vm.checkIfAttributeSelected(currentOption.id)
      },
      attrs: {
        "id": currentOption.id,
        "selected": currentOption.selected,
        "locked": currentOption.locked
      },
      on: {
        "click": _vm.updateSelectedAttribute
      }
    }, [_vm._v("\n          " + _vm._s(currentOption.name) + "\n\n          "), (currentOption.locked) ? _c('notification', {
      attrs: {
        "name": "lockedMessage",
        "nColor": "rgba(226, 144, 37, 0.85)",
        "isActive": _vm.lockedMessage
      },
      on: {
        "closeNotification": function($event) {
          _vm.lockedMessage = false
        }
      }
    }, [_c('div', {
      slot: "notification-body"
    }, [_vm._v("\n              " + _vm._s(currentOption.lockedMessage) + "\n            ")])]) : _vm._e()], 1)
  })], 2)])]), _vm._v(" "), _c('footerNav'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "categoryInfoModal",
      "isActive": _vm.categoryModal
    },
    on: {
      "closeModal": function($event) {
        _vm.categoryModal = false
      }
    }
  }, [_c('div', {
    slot: "modal-body"
  })]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "upgradeInfoModal",
      "isActive": _vm.upgradeModal
    },
    on: {
      "closeModal": function($event) {
        _vm.upgradeModal = false
      }
    }
  }, [_c('div', {
    slot: "modal-body"
  }, _vm._l((_vm.sharedState.accessories), function(upgrade) {
    return _c('div', {
      staticClass: "system-builder__modal--item"
    }, [_c('div', {
      staticClass: "system-builder__modal--item-image"
    }, [_c('img', {
      attrs: {
        "src": upgrade.images[0].image.url,
        "alt": upgrade.images[0].image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__modal--item-content"
    }, [_c('h4', [_vm._v(_vm._s(upgrade.post_title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(upgrade.description)
      }
    })])])
  }))]), _vm._v(" "), _c('notification', {
    attrs: {
      "name": "successNotification",
      "nColor": "#78bf5e",
      "isActive": _vm.successNotification
    },
    on: {
      "closeNotification": function($event) {
        _vm.successNotification = false
      }
    }
  }, [_c('div', {
    slot: "notification-body"
  }, [_vm._v("\n      Your vehicle is compatible!\n    ")])]), _vm._v(" "), _c('notification', {
    attrs: {
      "name": "warningNotification",
      "nColor": "#d25b4b",
      "isActive": _vm.warningNotification
    },
    on: {
      "closeNotification": function($event) {
        _vm.warningNotification = false
      }
    }
  }, [_c('div', {
    slot: "notification-body"
  }, [_vm._v("\n      Please check with a dealer near you for vehicle compatibility.\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-container--header"
  }, [_c('h2', [_vm._v("Build Your System")])])
}]}

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__modal",
    class: {
      'out': _vm.isActive === false, 'blowup': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        {
          _vm.$emit('closeModal')
        }
      }
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_vm._t("modal-body"), _vm._v(" "), _c('span', {
    staticClass: "system-builder__modal--close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "system-builder__main-upgrades--container"
  }, [_c('div', {
    staticClass: "system-builder__main-upgrades--wrapper"
  }, _vm._l((_vm.sharedState.accessories), function(accessory, index) {
    return (_vm.checkCompatibility(accessory.model_number)) ? _c('upgradeItem', {
      attrs: {
        "upgradeKey": index,
        "isActive": accessory.selected,
        "id": accessory.ID
      }
    }, [_c('div', {
      slot: "upgrade-image"
    }, [_c('img', {
      attrs: {
        "src": accessory.images.image.url,
        "alt": accessory.images.image.alt
      }
    })]), _vm._v(" "), _c('div', {
      slot: "upgrade-description"
    }, [_c('strong', [_vm._v(_vm._s(accessory.post_title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(accessory.description)
      }
    })])]) : _vm._e()
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "system-builder__main-upgrades--bottom-nav"
  }, [_c('div', {
    staticClass: "skip-link",
    on: {
      "click": _vm.goToViewSystem
    }
  }, [_vm._v("skip")]), _vm._v(" "), (_vm.sharedState.steps.selectUpgrades.passedValidation) ? _c('footerNav') : _vm._e()], 1)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__thank-you--section"
  }, [(_vm.alreadySent === false) ? _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("Thank you for providing feedback.")]), _vm._v(" "), _c('p', [_vm._v("Have fun with your new Compustar system.")])]) : _c('div', {
    staticClass: "system-builder__thank-you--container"
  }, [_c('h1', [_vm._v("This request is closed")]), _vm._v(" "), _c('p', [_vm._v("Thank you for providing your feedback.")]), _vm._v(" "), _c('a', {
    staticClass: "button__solid--blue",
    on: {
      "click": _vm.goToViewSystem
    }
  }, [_vm._v("Request Another Quote")])])])
},staticRenderFns: []}

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__contact-dealer--dealer-item"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--dealer-content"
  }, [_c('div', {
    staticClass: "dealer-details"
  }, [_vm._t("dealer-details")], 2), _vm._v(" "), (_vm.dealerPro === 'PRO') ? _c('div', {
    staticClass: "pro-logo"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__contact-dealer--dealer-cta-container"
  }, [(_vm.dealerPhone !== false) ? _c('div', {
    staticClass: "button__outline--primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.prepareTelLink(_vm.dealerPhone)
    }
  }, [_vm._v("Call")])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.sharedState.numberQuotesRequested) >= 5 && _vm.dealerEmail) ? _c('div', {
    staticClass: "button__outline--disabled"
  }, [_vm._m(0)]) : (_vm.dealerEmail && _vm.emailButtonLoading) ? _c('div', {
    staticClass: "button__solid--blue"
  }, [_c('spinner', {
    attrs: {
      "size": "small",
      "message": ""
    }
  })], 1) : (_vm.dealerEmail && _vm.emailSent) ? _c('div', {
    staticClass: "button__outline--disabled"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sent")])]) : (_vm.dealerEmail && _vm.emailSent === false) ? _c('div', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.sendQuoteToDealer()
      }
    }
  }, [_c('div', [_vm._v("Get E-Quote")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-times-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Send Limit Reached")])
}]}

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__cta--container"
  }, _vm._l((_vm.sharedState.currentStep.stickyNavigationOptions.buttons), function(button) {
    return _c('div', {
      class: [{
        'disabled-button': _vm.currentStepValidation(button.requireStepValidation)
      }, button.buttonClass],
      attrs: {
        "data-link": button.linkTo
      },
      on: {
        "click": _vm.handleButtonClick
      }
    }, [_vm._v("\n    " + _vm._s(button.text) + "\n  ")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'active-filter': _vm.active
    },
    on: {
      "click": _vm.featureItemClicked
    }
  }, [_vm._t("featureContent")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__dealer-followup--section"
  }, [(_vm.alreadySent) ? _c('div', {
    staticClass: "system-builder__dealer-followup--container"
  }, [_c('p', [_vm._v("Sorry, this request has been closed.")]), _vm._v(" "), _c('p', [_vm._v("Please submit another request if you would like to receive a quote from another dealer.")]), _vm._v(" "), _c('a', {
    staticClass: "button__solid--blue",
    on: {
      "click": _vm.goToViewSystem
    }
  }, [_vm._v("Request Another Quote")])]) : _c('div', {
    staticClass: "system-builder__dealer-followup--container"
  }, [_c('h1', [_vm._v("Follow-Up Reminder Sent")]), _vm._v(" "), _c('p', [_vm._v("We apologize that you have not been contacted yet by this dealer. A follow-up e-mail, regarding your E-Quote, has been sent to this dealer.")])])])
},staticRenderFns: []}

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__canadian--container"
  }, [_c('p', [_vm._v("\n    If you’d like to find an Authorized Compustar dealer near you in Canada, please contact one of our regional distributors listed below.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Western Canadian & Ontario Customers")]), _c('br'), _vm._v("\n    Please contact Staub Electronics, LTD."), _c('br'), _vm._v("\n    Toll-Free – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "tel:+18884702211"
    }
  }, [_vm._v("1(888)470-2211")]), _c('br'), _vm._v("\n    Website – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "https://www.staub.ca/",
      "target": "_blank"
    }
  }, [_vm._v("www.Staub.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Eastern Canadian Customers")]), _c('br'), _vm._v("\n    Please contact Robert Thibert, Inc."), _c('br'), _vm._v("\n    Toll-Free – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "tel:+18002681062"
    }
  }, [_vm._v("1(800)268-1062")]), _c('br'), _vm._v("\n    Website – "), _c('a', {
    staticClass: "text__link--blue",
    attrs: {
      "href": "http://www.rthibert.com/en-ca/",
      "target": "_blank"
    }
  }, [_vm._v("www.RThibert.com")])])])
}]}

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(101);
module.exports = __webpack_require__(152);


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[439]);


// WEBPACK FOOTER //
// static/js/app.js